import Zcd3 from 'libs/zcd3';

angular.module('zc.zenclerkS')
  .component('zcsInterestWidgetResults', {
    templateUrl: '/templates/zenclerk_s/sites/interest_widget/interest_widget_results.html',
    bindings: {
      project: '<',
      month: '<'
    },
    controller: zcsInterestWidgetResultsController,
  });

zcsInterestWidgetResultsController.$inject = ['$element', '$filter', '$timeout', '$translate', 'Campaign', 'MongoCampaignInterestWidgetStatsWithoutBounces', 'currencies'];
function zcsInterestWidgetResultsController($element, $filter, $timeout, $translate, Campaign, MongoCampaignInterestWidgetStatsWithoutBounces, currencies) {
  const vm = this;

  vm.currency = currencies[vm.project.currency];

  vm.minIwDate = moment('2016-09').toDate();

  // TODO: use interest widget creation time if later than 09-01
  vm.startAt = moment(vm.month, 'YYYY-MM').startOf('month').toDate();
  vm.endAt = moment(vm.month, 'YYYY-MM').endOf('month').toDate();

  if(moment().isBefore(vm.endAt)) {
    vm.endAt = moment().endOf('day').toDate();
  }

  vm.timerangeChanged = timerangeChanged;

  vm.$onInit = () => {
    Campaign.all({projectId: vm.project.id})
      .then(campaigns => {
        const iwCampaigns = _.filter(campaigns, campaign => campaign.interest_widget_id);
        const devices = _.countBy(iwCampaigns, 'campaign_device');

        // get only required devices
        let device = null;
        if(devices.sp && devices.pc) {
          device = null;
        } else if(devices.sp) {
          device = 'sp';
        } else if(devices.sp) {
          device = 'pc';
        }
        vm.device = device;

        prepareAndShowGraphs();
      });
  };

  function prepareAndShowGraphs() {
    getIwStats(vm.device)
      .then(iwStats => {
        const iwDataForGraph = createIwData(iwStats);

        vm.totalDeliveryCount = _.sumBy(
          iwDataForGraph,
          'iwDeliverySessionCount'
        );

        // we won't show anything if it's not delivered
        if(vm.totalDeliveryCount === 0) {
          return;
        }
        vm.totalDeliveryPercentage = getRoundedPercentage(iwDataForGraph, 'iwDeliverySessionCount', 'totalSessionCount');
        vm.totalUsagePercentage = getRoundedPercentage(iwDataForGraph, 'iwUserSessionCount', 'iwDeliverySessionCount');
        vm.totalUserConversion = _.sumBy(
          iwDataForGraph,
          'iwUserConversionPrice'
        );

        vm.averageIwConversionPercentage = getRoundedPercentage(iwDataForGraph, 'iwDeliveryConversionCount', 'iwDeliverySessionCount');
        vm.averageNoIwConversionPercentage = getRoundedPercentage(iwDataForGraph, 'noIwDeliveryConversionCount', 'noIwDeliverySessionCount');

        vm.averageIwCartButtonClickPercentage = getRoundedPercentage(iwDataForGraph, 'iwDeliveryCartButtonClickCount', 'iwDeliverySessionCount');
        vm.averageNoIwCartButtonClickPercentage = getRoundedPercentage(iwDataForGraph, 'noIwDeliveryCartButtonClickCount', 'noIwDeliverySessionCount');

        // do this in $timeout because the element might not be there yet and
        // then everything breaks
        $timeout(() => {
          createGraphs(iwDataForGraph);
        }, 500);
      });
  }

  function getRoundedPercentage(data, prop, totalProp) {
    return _.round((_.sumBy(data, prop) / _.sumBy(data, totalProp)) * 100, 2);
  }

  function createGraphs(iwDataForGraph) {
    const WIDTH = $element.find('.card.card-graph').eq(0).width();
    $element.find('.position-indicator').remove();

    const colors = {
      primary: '#1DD5A3',
      secondary: '#775FD3',
    };

    const graphs = {};

    function asYen(value) {
      const zcCurrency = $filter('zcCurrency');
      return zcCurrency(value, vm.currency.symbol, 0, vm.currency.suffix);
    }

    function asPercent(value) {
      return d3.format('.1f')(value) + '%';
    }

    // Delivery graph
    graphs.delivery = new Zcd3($element.find('.delivery-graph')[0], iwDataForGraph, {
      width: WIDTH,
      isBarChart: true, // TODO: get rid of this, just for padding
      tooltipFn: (d, opts) => [
        opts.timeFormats.day(d.date),
        $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_sesshon_kazu', { count: d.iwDeliverySessionCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.haishin_wariai', { ratio: _.round(d.iwDeliveryPercentage, 1).toFixed(1) }),
      ].join('<br>')
    });

    graphs.delivery.addSeries({
      name: 'delivery-session-count',
      type: 'bar',
      x: 'date',
      y: 'iwDeliverySessionCount',
      color: colors.primary,
    });

    graphs.delivery.addSeries({
      name: 'delivery-percentage',
      type: 'line',
      x: 'date',
      y: 'iwDeliveryPercentage',
      yAxis: 'right',
      yAxisTickFormat: asPercent,
      color: colors.secondary,
    });

    graphs.delivery.createVerticalPositionIndicator();

    // Cumulative conversion price graph
    graphs.cumulativeConversion = new Zcd3($element.find('.cumulative-conversion-graph')[0], iwDataForGraph, {
      width: WIDTH,
      tooltipFn: (d, opts) => [
        opts.timeFormats.day(d.date),
        $translate.instant('sites.interestWidget.interestWidgetResults.ruiseki_riyou_yuuzaanokonbaajon', { amount: asYen(d.iwCumulativeConversionPrice) }),
        $translate.instant('sites.interestWidget.interestWidgetResults.toujitsu_riyou_yuuzaanokonbaajon', { amount: asYen(d.iwUserConversionPrice) }),
        $translate.instant('sites.interestWidget.interestWidgetResults.toujitsu_riyousha_igai', { amount: asYen(d.allUserConversionPrice - d.iwUserConversionPrice) }),
      ].join('<br>')
    });

    graphs.cumulativeConversion.addSeries({
      type: 'area',
      x: 'date',
      y: 'iwCumulativeConversionPrice',
      yAxisTickFormat: asYen,
      color: colors.secondary,
    });

    graphs.cumulativeConversion.createVerticalPositionIndicator();

    // Cart button click rate graph
    graphs.cartButtonClickRate = new Zcd3($element.find('.cart-button-click-rate-graph')[0], iwDataForGraph, {
      width: WIDTH,
      tooltipFn: (d, opts) => [
        opts.timeFormats.day(d.date),
        `<b>${$translate.instant('sites.interestWidget.interestWidgetResults.hyouji_yuuzaa')}</b>`,
        $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_kazu', { count: d.iwDeliverySessionCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.kaatobotankurikku_kazu', { count: d.iwDeliveryCartButtonClickCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.kaatobotankurikku_ritsu', { rate: _.round(d.iwDeliveryCartButtonClickPercentage, 1).toFixed(1) }),
        `<b>${$translate.instant('sites.interestWidget.interestWidgetResults.hyouji_yuuzaa_igai')}</b>`,
        $translate.instant('sites.interestWidget.interestWidgetResults.sesshon_kazu', { count: d.noIwDeliverySessionCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.kaatobotankurikku_kazu', { count: d.noIwDeliveryCartButtonClickCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.kaatobotankurikku_ritsu', { rate: _.round(d.noIwDeliveryCartButtonClickPercentage, 1).toFixed(1) }),
      ].join('<br>')
    });

    graphs.cartButtonClickRate.addSeries({
      type: 'line',
      x: 'date',
      y: 'iwDeliveryCartButtonClickPercentage',
      yAxisTickFormat: asPercent,
      color: colors.primary,
    });

    graphs.cartButtonClickRate.addSeries({
      type: 'line',
      x: 'date',
      y: 'noIwDeliveryCartButtonClickPercentage',
      yAxisTickFormat: asPercent,
      color: colors.secondary,
    });

    graphs.cartButtonClickRate.createVerticalPositionIndicator();

    // Conversion rate graph
    graphs.conversionRate = new Zcd3($element.find('.conversion-rate-graph')[0], iwDataForGraph, {
      width: WIDTH,
      tooltipFn: (d, opts) => [
        opts.timeFormats.day(d.date),
        `<b>${$translate.instant('sites.interestWidget.interestWidgetResults.hyouji_yuuzaa')}</b>`,
        $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_kazu', { count: d.iwDeliverySessionCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.konbaajon_kazu', { count: d.iwDeliveryConversionCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.konbaajon_ritsu', { rate: _.round(d.iwDeliveryConversionPercentage, 1).toFixed(1) }),
        `<b>${$translate.instant('sites.interestWidget.interestWidgetResults.hyouji_yuuzaa_igai')}</b>`,
        $translate.instant('sites.interestWidget.interestWidgetResults.sesshon_kazu', { count: d.noIwDeliverySessionCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.konbaajon_kazu', { count: d.noIwDeliveryConversionCount }),
        $translate.instant('sites.interestWidget.interestWidgetResults.konbaajon_ritsu', { rate: _.round(d.noIwDeliveryConversionPercentage, 1).toFixed(1) }),
      ].join('<br>')
    });

    graphs.conversionRate.addSeries({
      type: 'line',
      x: 'date',
      y: 'iwDeliveryConversionPercentage',
      yAxisTickFormat: asPercent,
      color: colors.primary,
    });

    graphs.conversionRate.addSeries({
      type: 'line',
      x: 'date',
      y: 'noIwDeliveryConversionPercentage',
      yAxisTickFormat: asPercent,
      color: colors.secondary,
    });

    graphs.conversionRate.createVerticalPositionIndicator();
  }

  function createIwData(iwStats) {
    let dateRangeInDays = moment(vm.endAt).add(1, 'days').diff(vm.startAt, 'days');

    let iwCumulativeConversionPrice = 0;

    let iwDataForGraph = _.map(_.range(dateRangeInDays), dayNumber => {
      let date = moment(vm.startAt).add(dayNumber, 'days').startOf('day').toDate();
      let iwStat = _.find(iwStats, d => moment(d.start_at).isSame(date));
      let totalSessionCount = _.get(iwStat, 'all.session_count', 0);
      let iwDeliverySessionCount = _.get(iwStat, 'widget_received.session_count', 0);
      let iwUserSessionCount = _.get(iwStat, 'widget_received.cart_button_click_count', 0);
      let iwUserConversionPrice = _.get(iwStat, 'item_clicked.conversion_price', 0);
      let iwDeliveryConversionCount = _.get(iwStat, 'widget_received.conversion_count', 0);
      let iwDeliveryCartButtonClickCount = _.get(iwStat, 'widget_received.cart_button_click_count', 0);
      let iwDeliveryPercentage = 0;
      let iwDeliveryConversionPercentage = 0;
      let iwDeliveryCartButtonClickPercentage = 0;
      let noIwDeliveryConversionPercentage = 0;
      let noIwDeliveryCartButtonClickPercentage = 0;
      let noIwDeliverySessionCount = _.get(iwStat, 'widget_not_received.session_count', 0);
      let noIwUserSessionCount = _.get(iwStat, 'all.session_count', 0) - iwUserSessionCount;
      let noIwDeliveryConversionCount = _.get(iwStat, 'widget_not_received.conversion_count', 0);
      let noIwDeliveryCartButtonClickCount = _.get(iwStat, 'widget_not_received.cart_button_click_count', 0);
      let allUserConversionPrice = _.get(iwStat, 'all.conversion_price', 0);

      if(iwStat) {

        if(totalSessionCount) {
          iwDeliveryPercentage = iwDeliverySessionCount / totalSessionCount * 100;
        }

        iwCumulativeConversionPrice += iwUserConversionPrice;

        // iw and non iw conversion and cart click rates
        if(iwStat.widget_received.session_count) {
          iwDeliveryConversionPercentage = iwStat.widget_received.conversion_count / iwStat.widget_received.session_count * 100;
          iwDeliveryCartButtonClickPercentage = iwStat.widget_received.cart_button_click_count / iwStat.widget_received.session_count * 100;
        }

        if(iwStat.widget_not_received.session_count) {
          noIwDeliveryConversionPercentage = iwStat.widget_not_received.conversion_count / iwStat.widget_not_received.session_count * 100;
          noIwDeliveryCartButtonClickPercentage = iwStat.widget_not_received.cart_button_click_count / iwStat.widget_not_received.session_count * 100;
        }
      }

      return {
        date,
        totalSessionCount,
        iwDeliveryPercentage,
        iwCumulativeConversionPrice,
        allUserConversionPrice,

        iwDeliverySessionCount,
        iwUserSessionCount,
        iwDeliveryConversionCount,
        iwDeliveryCartButtonClickCount,
        iwUserConversionPrice,
        iwDeliveryConversionPercentage,
        iwDeliveryCartButtonClickPercentage,

        noIwDeliverySessionCount,
        noIwUserSessionCount,
        noIwDeliveryConversionCount,
        noIwDeliveryCartButtonClickCount,
        noIwDeliveryConversionPercentage,
        noIwDeliveryCartButtonClickPercentage,
      };
    });

    return iwDataForGraph;
  }

  function getIwStats(device) {
    return MongoCampaignInterestWidgetStatsWithoutBounces.find({
      dimension: 'daily',
      apikey: vm.project.apikey,
    }, {
      device: device,
      start_at: {
        $gte: vm.startAt,
        $lt: moment(vm.endAt).endOf('day').toDate(),
      }
    });
  }

  function timerangeChanged(min, max) {
    vm.startAt = min;
    vm.endAt = max;
    prepareAndShowGraphs();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/interest_widget/interest_widget_results.js